import { render } from "./GoalDetails.vue?vue&type=template&id=3490a5f6"
import script from "./_GoalDetails.js?vue&type=script&lang=js&external"
export * from "./_GoalDetails.js?vue&type=script&lang=js&external"

import "./_GoalDetails.less?vue&type=style&index=0&lang=less&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__